export const StatusEnum = [
    { id: 'enabled', name: 'Enabled' },
    { id: 'disabled', name: 'Disabled' }
];

